// Story 6.35 (ADO-1693, FR90) — applies the resolved per-tenant brand to the
// document root whenever it changes. Mounted once at the composition root
// (main.tsx), inside AuthProvider so it sees the brand the session read
// hydrates. Renders nothing — it is a side-effect-only sink, deliberately not a
// provider (the brand lives in `useSessionStore`, the same place role/depots do).
//
// useLayoutEffect (not useEffect): the branded page is gated behind LoadingRoute
// until the session read resolves the brand, but a brand change that lands in the
// same commit as a paint (e.g. the LoadingRoute→page transition, or a mid-session
// tenant switch) must set `data-brand` BEFORE the browser paints, so no frame
// renders the wrong-brand chrome. This is a client-only SPA (no SSR), so the
// server/useLayoutEffect mismatch warning does not apply.
import { useLayoutEffect } from 'react';
import { useSessionStore } from '../auth/useSessionStore';
import { applyBrandTheme } from './brand';

export function BrandThemeApplier(): null {
  const brand = useSessionStore((s) => s.brandConfig);
  useLayoutEffect(() => {
    applyBrandTheme(brand);
  }, [brand]);
  return null;
}
